import {
  Box,
  TableCell,
  TableRow,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PageTitle from "../../../../../components/pageTitle/PageTitle";
import TableDesign from "../../../../../components/common/table/TableDesign";
import CustomButton from "../../../../../components/common/button/CustomButton";
import { contracts, tableHeadings } from "./contractsUtils";
import StorageContract from "./storageContract";
import { useDispatch, useSelector } from "react-redux";
import {
  getContractListAction,
  getSingleContractAction,
  setCreateContractResponseAction,
} from "../../../../../store/reducers/contractStorageSlice";
import dayjs from "dayjs";

const ContractList = ({ generateId }: any) => {
  const dispatch = useDispatch();
  const [showContract, setShowContract] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  // Action menu state
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [actionRow, setActionRow] = useState<any>(null);

  const { contractList, contractPagination, isCreateContractResponse } =
    useSelector((state: any) => state.contractStorage);
  const { userProfile } = useSelector((state: any) => state?.user);

  const [filterData, setFilterData] = useState({
    leadId: null,
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    if (filterData?.page && filterData?.limit && generateId) {
      dispatch(
        getContractListAction({
          ...filterData,
          leadId: generateId,
        }),
      );
    }
  }, [dispatch, filterData, generateId]);

  useEffect(() => {
    if (isCreateContractResponse) {
      dispatch(
        getContractListAction({
          ...filterData,
          leadId: generateId,
        }),
      );
      handleClose();
      dispatch(setCreateContractResponseAction(false));
    }
  }, [isCreateContractResponse]);

  const handleClose = () => {
    setShowContract(false);
    setSelectedRow(null);
  };

  /**
   * Open 3-dot action menu
   */
  const handleActionClick = (
    event: React.MouseEvent<HTMLElement>,
    row: any,
  ) => {
    event.stopPropagation();

    setAnchorEl(event.currentTarget);
    setActionRow(row);
  };

  /**
   * Close 3-dot action menu
   */
  const handleActionMenuClose = () => {
    setAnchorEl(null);
    setActionRow(null);
  };

  /**
   * Edit Contract
   */
  const handleEditClick = () => {
    if (!actionRow) return;

    setShowContract(true);
    setSelectedRow(actionRow);

    handleActionMenuClose();
  };

    /**
   * Generate Invoice
   */
  const handleGenerateInvoice = () => {
    if (!actionRow) return;

    console.log("Generate Invoice for contract:", actionRow);

    // TODO:
    // dispatch(generateInvoiceAction({
    //   contractId: actionRow?.id,
    //   leadId: generateId,
    // }));

    handleActionMenuClose();
  };

  useEffect(() => {
    if (selectedRow) {
      dispatch(getSingleContractAction(selectedRow));
    }
  }, [dispatch, selectedRow]);

  return (
    <>
      <PageTitle
        title="List of Contracts"
        button="Manage Contract"
        onClick={() => setShowContract(true)}
      />
      <StorageContract show={showContract} setShow={setShowContract} />
      <Box
        sx={{
          bgcolor: "#fff",
          height: {
            xs: "auto",
            sm: contractList?.length > 1 ? "auto" : "20vh",
          },
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          padding: "0px",
          overflow: "hidden",
        }}
      >
        <TableDesign
          tableHeadings={tableHeadings}
          tableHeadColor={"#02906f"}
          cellColor={"#fff"}
          pagination={contractList?.length > 0 ? contractPagination : null}
          isLoader={false}
          stickyHeader={true}
          filterOption={() => {}}
          setFilterOption={() => {}}
          extraCSS={{
            height: "calc(100%)",
          }}
        >
          {contractList?.length > 0 ? (
            contractList?.map((val: any, idx: number) => (
              <TableRow
                key={val?.id}
                sx={{
                  cursor: "pointer",
                  marginTop: "10px",
                  padding: "4px !important",
                  borderRadius: "20px !important",
                  height: "20px !important",
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                    outline: "2px solid #f0f0f0",
                    borderRadius: "0px !important",
                    outlineOffset: "-2px !important",
                  },
                }}
              >
                <TableCell>{val?.title}</TableCell>
                <TableCell>{val?.contractType}</TableCell>
                <TableCell>
                  {val?.startDate
                    ? dayjs(val?.startDate).format(
                        userProfile?.dateFormat
                          ? userProfile?.dateFormat
                          : "DD/MM/YYYY",
                      )
                    : ""}
                </TableCell>
                <TableCell>
                  {val?.endDate
                    ? dayjs(val?.endDate).format(
                        userProfile?.dateFormat
                          ? userProfile?.dateFormat
                          : "DD/MM/YYYY",
                      )
                    : ""}
                </TableCell>
                {/* Action */}
                <TableCell align="center">
                  <IconButton
                    size="small"
                    onClick={(event) => handleActionClick(event, val)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={tableHeadings?.length} align="center">
                {`No Data Found!`}
              </TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Box>

      {/* Contract Actions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleActionMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleEditClick}>Edit Contract</MenuItem>

        <MenuItem onClick={handleGenerateInvoice}>Generate Invoice</MenuItem>
      </Menu>
    </>
  );
};

export default ContractList;
